function safeNumberFormat(value, locale, opts = {}) {
  try {
    return new Intl.NumberFormat(locale, opts).format(value);
  } catch {
    const entriesToRemove = {
      // @ts-expect-error: This function corrects a deprecated API in older browsers, so the type is intentionally wrong
      currencyDisplay: "narrow",
      currencySign: "accounting",
      style: "unit"
    };
    const keysToRemove = /* @__PURE__ */ new Set(["signDisplay", "compactDisplay"]);
    Object.keys(opts).forEach(
      (key) => {
        if (keysToRemove.has(key) || entriesToRemove[key] === opts[key]) {
          delete opts[key];
        }
      }
    );
    try {
      return new Intl.NumberFormat(locale, opts).format(value);
    } catch {
      return new Intl.NumberFormat(locale).format(value);
    }
  }
}
export {
  safeNumberFormat as default
};
//# sourceMappingURL=safe-number-format.js.map
